(() => {
  function initStickyAddToCart() {
    const productSection = document.querySelector('.shopify-section-main-product-inner[data-prodify]');
    const stickyBar = document.querySelector('[data-sticky-atc]');

    if (!productSection || !stickyBar) {
      return;
    }

    // Modal elements
    const notifyModal = stickyBar.querySelector('[data-sticky-notify-modal]');
    const notifyModalClose = stickyBar.querySelector('[data-sticky-notify-modal-close]');
    const notifyMeBtn = stickyBar.querySelector('[data-sticky-notify-me]');
    
    // Close sticky bar button
    const closeBtns = stickyBar.querySelectorAll('[data-sticky-atc-close]');
    
    // Explore similar
    const exploreSimilarBtn = stickyBar.querySelector('[data-sticky-explore-similar]');

    const stickyButtons = stickyBar.querySelectorAll('[data-sticky-atc-button]');
    const stickyImages = stickyBar.querySelectorAll('[data-sticky-atc-image]');
    const stickyTitles = stickyBar.querySelectorAll('.product-sticky-atc__title');

    const productTitle = stickyBar.getAttribute('data-product-title') || '';

    const getProductForm = () => productSection.querySelector('[data-prodify-product-form]');
    const getMainAddButton = () => {
      const productForm = getProductForm();
      return productForm ? productForm.querySelector('[name="add"]') : null;
    };

    const getVariantImageUrl = () => {
      const currentVariant = window && window.prodify ? window.prodify.currentVariant : null;
      const featuredMedia = currentVariant && currentVariant.featured_media ? currentVariant.featured_media : null;

      if (featuredMedia && featuredMedia.id) {
        const variantImage = productSection.querySelector(`.product-gallery__track img[data-media-id="${featuredMedia.id}"]`);

        if (variantImage && variantImage.currentSrc) {
          return variantImage.currentSrc;
        }

        if (variantImage && variantImage.src) {
          return variantImage.src;
        }
      }

      const fallbackImage = productSection.querySelector('.product-gallery__track img[data-media-id], .product-gallery__track img');

      if (fallbackImage && fallbackImage.currentSrc) {
        return fallbackImage.currentSrc;
      }

      if (fallbackImage && fallbackImage.src) {
        return fallbackImage.src;
      }

      return '';
    };

    // Format money helper
    const formatMoney = (cents) => {
      const amount = (cents / 100).toFixed(2);
      const symbol = window.Shopify && window.Shopify.currency && window.Shopify.currency.symbol || 'Rs. ';
      const activeCurrency = window.Shopify && window.Shopify.currency && window.Shopify.currency.active || '';
      
      if (activeCurrency === 'INR' || symbol === 'INR') {
        return 'Rs. ' + amount;
      }
      return symbol + amount;
    };

    const syncStickyState = () => {
      const currentVariant = window && window.prodify ? window.prodify.currentVariant : null;
      const addButton = getMainAddButton();

      if (!currentVariant || !addButton) {
        return;
      }

      // 1. Toggle available / sold-out state container
      const isAvailable = currentVariant.available;
      if (isAvailable) {
        stickyBar.classList.add('is-available');
        stickyBar.classList.remove('is-sold-out');
      } else {
        stickyBar.classList.add('is-sold-out');
        stickyBar.classList.remove('is-available');
      }

      // 2. Sync title with variant options (e.g. "Cold Pressed Groundnut Oil (1 Litre)")
      let fullTitle = productTitle;
      if (currentVariant.title && currentVariant.title !== 'Default Title') {
        fullTitle += ` (${currentVariant.title})`;
      }
      stickyTitles.forEach(el => {
        el.textContent = fullTitle;
      });

      // 3. Sync Image
      const currentImage = getVariantImageUrl();
      stickyImages.forEach(img => {
        if (currentImage && img.getAttribute('src') !== currentImage) {
          img.setAttribute('src', currentImage);
        }
      });

      // 4. Sync Discount / Price Details (in stock state only)
      if (isAvailable) {
        const compareAtPrice = currentVariant.compare_at_price;
        const price = currentVariant.price;
        const discountWrapper = stickyBar.querySelector('[data-sticky-discount-wrapper]');
        
        if (discountWrapper) {
          if (compareAtPrice && compareAtPrice > price) {
            const saveAmount = compareAtPrice - price;
            const savePercent = Math.round((saveAmount / compareAtPrice) * 100);
            
            const percentEl = discountWrapper.querySelector('[data-sticky-discount-percent]');
            if (percentEl) percentEl.textContent = savePercent;
            
            const amountEl = discountWrapper.querySelector('[data-sticky-saved-amount]');
            if (amountEl) amountEl.textContent = formatMoney(saveAmount);
            
            discountWrapper.style.display = 'inline-flex';
          } else {
            discountWrapper.style.display = 'none';
          }
        }
      }

      // 5. Sync Button label & behavior with Cart State
      const cart = window.liquidAjaxCart && window.liquidAjaxCart.cart;
      const cartItem = cart && cart.items.find(item => item.variant_id === currentVariant.id);
      const quantityInCart = cartItem ? cartItem.quantity : 0;
      
      const availableButton = stickyBar.querySelector('.product-sticky-atc__button--available');
      const labelEl = stickyBar.querySelector('[data-sticky-label]');
      
      if (availableButton) {
        const buttonTextEl = availableButton.querySelector('[data-sticky-atc-button-text]');
        if (quantityInCart > 0) {
          if (buttonTextEl) buttonTextEl.textContent = `View Cart (${quantityInCart})`;
          if (labelEl) labelEl.textContent = 'ADDED TO CART';
          availableButton.setAttribute('data-action', 'view-cart');
        } else {
          if (buttonTextEl) buttonTextEl.textContent = 'Add to cart';
          if (labelEl) labelEl.textContent = 'PRODUCT AVAILABLE';
          availableButton.removeAttribute('data-action');
        }

        // Enable/Disable based on main form processing state
        if (addButton.hasAttribute('disabled')) {
          availableButton.setAttribute('disabled', 'disabled');
        } else {
          availableButton.removeAttribute('disabled');
        }
      }
    };

    // Click handler for Available Add/View Cart button
    stickyButtons.forEach(button => {
      button.addEventListener('click', (e) => {
        const action = button.getAttribute('data-action');
        if (action === 'view-cart') {
          // Open minicart drawer
          if (window.Alpine && window.Alpine.store) {
            const store = window.Alpine.store('global');
            if (store) store.isMinicartVisible = true;
          }
          return;
        }

        const addButton = getMainAddButton();
        if (!addButton || addButton.hasAttribute('disabled')) {
          return;
        }

        addButton.click();
        requestAnimationFrame(syncStickyState);
        setTimeout(syncStickyState, 200);
      });
    });

    let isStickyClosedByUser = false;

    // Close buttons handler
    closeBtns.forEach(btn => {
      btn.addEventListener('click', () => {
        isStickyClosedByUser = true;
        stickyBar.classList.add('product-sticky-atc--hidden');
      });
    });

    // Explore similar button handler
    if (exploreSimilarBtn) {
      exploreSimilarBtn.addEventListener('click', () => {
        const suggestionsSec = document.querySelector('.product-suggestions-section');
        if (suggestionsSec) {
          suggestionsSec.scrollIntoView({ behavior: 'smooth' });
        }
      });
    }

    // Modal toggle handlers
    if (notifyMeBtn && notifyModal) {
      notifyMeBtn.addEventListener('click', () => {
        notifyModal.style.display = 'flex';
      });
    }

    if (notifyModalClose && notifyModal) {
      notifyModalClose.addEventListener('click', () => {
        notifyModal.style.display = 'none';
      });
      notifyModal.addEventListener('click', (e) => {
        if (e.target === notifyModal) {
          notifyModal.style.display = 'none';
        }
      });
    }

    // Listeners for variant/cart changes
    productSection.addEventListener('change', () => {
      requestAnimationFrame(syncStickyState);
      setTimeout(syncStickyState, 120);
    });

    productSection.addEventListener('prodify:variant-media', () => {
      requestAnimationFrame(syncStickyState);
    });

    document.addEventListener('liquid-ajax-cart:request-end', () => {
      requestAnimationFrame(syncStickyState);
    });

    const observer = new MutationObserver(() => {
      requestAnimationFrame(syncStickyState);
    });

    observer.observe(productSection, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['disabled']
    });

    // Scroll observer to show/hide sticky ATC based on main Add To Cart button visibility
    const formActions = productSection.querySelector('.product-form__actions') || getMainAddButton();
    if (formActions) {
      // Initially hide the sticky bar
      stickyBar.classList.add('product-sticky-atc--hidden');
      
      const checkVisibility = () => {
        if (isStickyClosedByUser) return;
        
        const rect = formActions.getBoundingClientRect();
        // Check if the form actions are completely scrolled out of view at the top
        if (rect.bottom < 0) {
          stickyBar.classList.remove('product-sticky-atc--hidden');
        } else {
          stickyBar.classList.add('product-sticky-atc--hidden');
        }
      };

      const intersectionObserver = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            stickyBar.classList.add('product-sticky-atc--hidden');
          } else {
            checkVisibility();
          }
        });
      }, { threshold: 0, rootMargin: '0px' });
      
      intersectionObserver.observe(formActions);
      
      // Fallback scroll listener for smooth transitions
      window.addEventListener('scroll', checkVisibility, { passive: true });
      // Run once on load
      checkVisibility();
    }

    syncStickyState();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStickyAddToCart, { once: true });
  } else {
    initStickyAddToCart();
  }
})();
